import translationStore          from '@widesk-ui/stores/translationStore';
import modelsFr                  from '@/models/localization/fr.json';
import { setModelLocalizedData } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import { setLocale }             from '@widesk-core/locale';
import { setLanguages }          from '@widesk-core/languages';
import languages                 from '@/languages';

setLocale('fr');
setLanguages(languages);

setModelLocalizedData(modelsFr);

const translations = {
	fr: { 'title': 'Français', 'image': '/flags/fr.png' },
	en: { 'title': 'Anglais', 'image': '/flags/en.png' },
	jp: { 'title': 'Japonais', 'image': '/flags/jp.png' },
};

translationStore.setTranslations(translations);
